import { Controller } from "@hotwired/stimulus"

// Linhas dinâmicas genéricas para nested attributes (perguntas de checklist,
// composição de etapas do produto). O <template> guarda uma linha em branco
// com child_index NEW_RECORD, trocado por um índice único ao adicionar.
export default class extends Controller {
  static targets = ["list", "template", "row", "destroyField"]

  add() {
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.listTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const row = event.target.closest("[data-nested-rows-target='row']")
    if (!row) return

    const persisted = row.querySelector("input[name$='[id]']")
    if (persisted) {
      const destroyField = row.querySelector("[data-nested-rows-target='destroyField']")
      if (destroyField) destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }
}
